import React from "react";

import { ShimmerEffect } from "./styles";

export const Shimmer = ({ children, width, height, border = 8, ...rest }) => {
	return (
		<ShimmerEffect width={width} height={height} border={border} {...rest}>
			{children}
		</ShimmerEffect>
	);
};

export default Shimmer;
